<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <p
              class="mb-0 text grey--text text--darken-1"
              :class="titleClassSize"
            >
              Our commitment as the Acapedia community
            </p>
            <h3
              class="heading primary--text"
              :class="smallMobileSize ? 'heading-m-small' : 'heading-m-large'"
            >
              Professional Integrity
            </h3>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          class="margin-top-body"
        >
          <v-col
            v-for="(item, index) in items"
            :key="index"
            :index="index"
            class="panel pa-2 pa-sm-4"
            cols="12"
            sm="4"
          >
            <ph-scroll
              v-if="index === 0"
              weight="thin"
              :size="sizeForIcon"
              color="var(--v-secondary-base)"
            />
            <ph-handshake
              v-if="index === 1"
              weight="thin"
              :size="sizeForIcon"
              color="var(--v-secondary-base)"
            />
            <ph-circle-wavy-warning
              v-if="index === 2"
              weight="thin"
              :size="sizeForIcon"
              color="var(--v-secondary-base)"
            />
            <div class="panel-container">
              <h3
                class="text grey--text text-l-large-bold text--darken-1 mb-1"
                :class="smallMobileSize ? 'text-m-large-bold' : 'text-l-large-bold'"
              >
                {{ item.title }}
              </h3>
              <h3
                class="text grey--text text--darken-4 mb-0"
                :class="smallMobileSize ? 'text-m-large-regular' : 'text-l-large-regular'"
              >
                {{ item.text }}
              </h3>
            </div>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          class="btn-container mt-sm-6"
        >
          <v-col
            cols="12"
            class="text-right"
          >
            <v-btn
              ripple
              depressed
              :block="mobileSize || smallMobileSize"
              :height="mobileSize || smallMobileSize ? '44px' : '36px'"
              color="primary white--text"
              class="heading heading-s-small align-self-center unaltered-text-cap shadow-light-button px-6"
              @click="nextStep"
            >
              Continue
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { PhScroll, PhHandshake, PhCircleWavyWarning } from 'phosphor-vue';
export default {
  components: { PhScroll, PhHandshake, PhCircleWavyWarning },
  data: () => ({
    items: [
      {
        id: 0,
        title: 'Professionalism',
        text: 'Acapedia takes ethics and professionalism seriously, and we expect our users to do the same.',
      },
      {
        id: 1,
        title: 'Good faith',
        text: 'You are expected to make a good-faith effort to read, understand and interpret the article.',
      },
      {
        id: 2,
        title: 'Trust',
        text: 'We monitor user activity closely and will audit any unusual behavior.',
      },
    ],
  }),
  computed: {
    sizeForIcon() {
      if (this.smallMobileSize) {
        return '24px';
      }

      return '48px';
    },
    mobileSize() {
      return this.$breakpoint.isMobile;
    },
    smallMobileSize() {
      return this.$breakpoint.isSmallMobile;
    },
    titleClassSize() {
      if (this.smallMobileSize) {
        return 'text-m-small-bold';
      }

      if (this.mobileSize) {
        return 'text-m-large-bold';
      }

      return 'text-l-large-bold';
    }
  },
  methods: {
    nextStep() {
      this.$emit('next-step');
    },
  },
};
</script>

<style scoped lang="scss">
.panel {
  flex: 1;
  background-color: var(--v-card-base);
  border-radius: 4px;
}
.margin-top-body {
  gap: 16px;
  margin-top: 24px;
}

@media #{map-get($display-breakpoints, 'mobile-only')} {
  .panel {
    gap: 16px;
  }
  .margin-top-body {
    margin-top: 32px;
  }
  .panel-container {
    margin-right: 16px;
  }
}

@media #{map-get($display-breakpoints, 'mobile-and-down')} {
  .panel {
    display: flex;
    flex: 0 0 100%;
  }
  .panel-container {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .btn-container {
    position: absolute;
    z-index: 5;
    width: calc(100vw - 48px);
    margin-left: 0;
    margin-right: 0;
    bottom: 24px;
  }
}

@media #{map-get($display-breakpoints, 'small-mobile-only')} {
  .margin-top-body {
    margin-top: 16px;
  }
  .panel {
    gap: 8px;
  }
}
</style>
